import Background from '../ui/Background';
import ClickableMixin from './mixins/ClickableMixin';
import ContainableMixin from './mixins/ContainableMixin';
import mixin from '../privates/utils/mixin';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';

/**
 * @class Container
 * @summary A container for Repeater items.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @mixes $w.Background
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @memberof $w
 * @queryable
 * @tagname cell
 * @viewername wysiwyg.viewer.components.MediaContainer
 * @definitionId wysiwyg.viewer.components.MediaContainer
 */

class Container extends Background {}

mixin(Container.prototype, HiddenCollapsedMixin.prototype);
mixin(Container.prototype, ClickableMixin.prototype);
mixin(Container.prototype, ContainableMixin.prototype);

export default Container;
